<template>
  <div style="height: 100%">
    <v-navigation-drawer v-model="drawer" absolute>
      <v-list class="pa-1">
        <v-list-item tag="div">
          <v-list-item-content>
            <v-list-item-title>Recent location</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-btn icon @click.stop="drawer = !drawer">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-list class="pt-0" dense>
        <v-divider light></v-divider>

        <v-list-item data-cy="authComponentAccessFindLocationBtn" v-for="item in recentLocation" :key="item.code"
          class="py-2" @click="setLocation(item)">
          <v-list-item-content>
            <v-list-item-title>{{ item.name }}</v-list-item-title>
            <v-list-item-subtitle v-html="item.code"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div class="center-content">
      <v-col align="center" class="fill-hight">
        <v-col>
          <v-img alt="Cellsmart Logo" class="shrink mr-2" contain src="../../../assets/fullLogo.png"
            transition="scale-transition" width="250" />
        </v-col>
        <v-col>
          <div class="font-weight-bold title">Find Your Location</div>
        </v-col>
        <v-col class="mt-3" cols="12" sm="4">
          <v-text-field label="Location Code" type="tel" outlined dense hide-details clearable @keyup.enter="checkLocationCode"
            v-model="locationCode"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field label="Name" outlined hide-details clearable dense v-model="deviceName"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-btn color="primary" block @click="checkLocationCode">
            Submit
          </v-btn>
        </v-col>
        <v-col cols="12" sm="4">
          <v-btn text @click.stop="drawer = !drawer">
            Recent Locations
          </v-btn>
        </v-col>




      </v-col>
    </div>


    <v-footer app color="#F3F8FC">
      <v-layout align-center justify-center column fill-heigh>
        <div class="text-xs-center mb-3 mt-3">
          Don't have account?
          <a href="javascript:void(0)" @click="openSignUp">
            <b data-cy="loginSignUp">Sign Up</b>
          </a>
        </div>
      </v-layout>
    </v-footer>

    <!-- <v-footer app>
      <v-card-text>
        <span>Start Screen</span>
        <v-select
          :items="place"
          v-model="selectedPlace"
          item-text="name"
          hide-details
          outlined
          solo
          dense
        ></v-select>
      </v-card-text>
    </v-footer> -->
  </div>
</template>

<script>
import("../../../assets/logo.png");
import authService from "@/modules/Authentication/service.js";
const { validationMixin } = require("vuelidate");
const { required } = require("vuelidate/lib/validators");

export default {
  name: "locationCode-view",
  data() {
    return {
      place: ["Time Clock", "Admin Panel"],
      selectedPlace: "Admin Panel",
      drawer: false,
      recentLocation: [],
      locationCode: null,
      deviceCode: null,
      deviceName: null,
      location: null,
    };
  },
  watch: {
    selectedPlace(val) {
      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`,
        val
      );
    },
  },
  created() {
    // console.log("dfdfasd", process.env.VUE_APP_STORAGE_PREFIX);
    localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);

    const selectedScreen = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`
    );
    // console.log('selectedScreen', selectedScreen)
    if (selectedScreen) this.selectedPlace = selectedScreen;
    if (localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`)) {
      this.locationCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`
      );
      this.deviceName = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`
      );
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}code`);
    } else {
      console.log(
        "this.locationCode",
        localStorage.getItem("csp4_terminal_code")
      );
      this.locationCode = localStorage.getItem("csp4_terminal_code");
      this.deviceName = "phone";
    }
    this.recentLocation = JSON.parse(
      localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
      )
    );
    if (!this.recentLocation) this.recentLocation = [];
  },
  methods: {
    openSignUp() {
      console.log("open sign up");
      this.$router.push({ path: "/signUp" });
    },
    setLocation(location) {
      this.locationCode = location.code;
      this.checkLocationCode();
    },
    async setRecentLocation(location) {
      let found = true;
      if (this.recentLocation.length !== 0) {
        await Promise.all(
          this.recentLocation.map((row) => {
            if (row.code === location.code) {
              found = false;
            }
          })
        );
      }

      if (found) {
        this.recentLocation.push({ name: location.name, code: location.code });
      }

      localStorage.setItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`,
        JSON.stringify(this.recentLocation)
      );
    },
    randomString(length, chars) {
      let result = "";
      for (let i = length; i > 0; --i) {
        result += chars[Math.floor(Math.random() * chars.length)];
      }
      return result;
    },
    checkLocationCode() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
      } else {
        authService
          .getLocation(this.locationCode)
          .then((response) => {
            this.location = response.data;
            this.setRecentLocation(this.location);
            localStorage.setItem(
              `${process.env.VUE_APP_STORAGE_PREFIX}location`,
              JSON.stringify(this.location)
            );

            localStorage.setItem(
              `${process.env.VUE_APP_STORAGE_PREFIX}code`,
              this.locationCode
            );
            localStorage.setItem(
              `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`,
              this.deviceName
            );

            // localStorage.setItem(
            //   `${process.env.VUE_APP_STORAGE_PREFIX}selectedScreen`,
            //   this.selectedPlace
            // );

            this.$router.push({ name: "authentication-employee-login" });

            // if (this.selectedPlace === "Time Clock") {
            //   this.$router.push({ name: "clockInOut" });
            // } else {
            //   this.$router.push({ name: "authentication-employee-login" });
            // }

            // this.$router.push({
            //   path: "login",
            //   name: "login",
            //   params: {
            //     ...this.$route.query,
            //     locationInstance: {
            //       code: this.locationCode,
            //       deviceName: this.deviceName,
            //       deviceCode: this.deviceCode,
            //       location: this.location,
            //     },
            //   },
            // });
          })
          .catch((error) => {
            if (error) {
              switch (error.status) {
                case 404:
                  this.$swal("Location", "Code Not Found", "error");
                  break;
                default:
                // do nothing
              }
            }
          });
      }
    },
    // submit() {
    //   if (this.locationCode && this.deviceName) {
    //     localStorage.setItem(
    //       `${process.env.VUE_APP_STORAGE_PREFIX}code`,
    //       this.locationCode
    //     );
    //     localStorage.setItem(
    //       `${process.env.VUE_APP_STORAGE_PREFIX}deviceName`,
    //       this.deviceName
    //     );
    //   }
    //   this.$router.push({
    //     name: "login",
    //     params: {
    //       locationCode: this.locationCode,
    //       deviceName: this.deviceName,
    //     },
    //   });
    // },
  },
  mixins: [validationMixin],
  validations: {
    deviceName: {
      required,
    },
    locationCode: {
      required,
    },
  },
};
</script>

<style scoped>
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  /* Make sure the container takes full height */
}
</style>